export default __webpack_public_path__ + "static/media/price_tag.7cff48fe.png";